import { render, staticRenderFns } from "./BiomassMapsModuleRoot.vue?vue&type=template&id=ac507cd0&scoped=true&lang=html&"
import script from "./BiomassMapsModuleRoot.vue?vue&type=script&lang=js&"
export * from "./BiomassMapsModuleRoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac507cd0",
  null
  
)

export default component.exports